import React, { ReactElement } from 'react';
import classNames from 'classnames';

import './badge.scss';

const Badge: React.FC<{
    className?: string;
    size: 'xs'|'sm'|'md'|'lg';
    color: 'green'|'blue'|'orange'|'link';
    weight?: '500'|'600'|'700';
    textAlign?: 'center'|'left'|'right';
    outline?: boolean;
}> = ({
    className,
    color,
    children,
    weight = '500',
    size = 'md',
    textAlign = 'center',
    outline = false
}): ReactElement => (

    <span
        className={classNames({
            [outline ? `badge--${color}--outline` : `badge--${color}`]: true,
            [className || '']: className,
            [`badge--${size}`]: true,
            [`badge--fw-${weight}`]: true,
            [`badge--ta-${textAlign}`]: true,
            badge: true
        })}
    >
        {children}
    </span>
);

export default Badge;
